import * as React from "react"
import { IconProps } from "./interfaces/IconProps.interface"

function googleIcon(props: IconProps) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={19} height={16} fill="none" {...props}>
            <path
                fill="#4285F4"
                d="M13.168 9.352a2.886 2.886 0 0 1-.514 1.141l2.116 1.889c.99-1.11 1.546-2.567 1.546-4.244 0-.472-.048-.926-.136-1.362H9.152v2.576h4.016Z"
            />
            <path
                fill="#34A853"
                d="M9.152 11.998c-1.944 0-3.589-1.171-4.175-2.746l-2.298 2.05a6.8 6.8 0 0 0 1.195 1.395 7.575 7.575 0 0 0 2.422 1.443 8.247 8.247 0 0 0 2.856.507c2.015 0 3.704-.596 4.939-1.614.244-.201.471-.418.68-.651l-2.117-1.889a3.275 3.275 0 0 1-.975.87c-.669.399-1.523.635-2.527.635Z"
            />
            <path
                fill="#FBBC23"
                d="M4.742 7.987c0-.44.085-.866.235-1.265l-2.298-2.05a6.073 6.073 0 0 0-.99 3.316c0 .874.193 1.74.568 2.548.122.264.263.52.422.767l2.298-2.05c-.15-.4-.235-.827-.235-1.266Z"
            />
            <path
                fill="#EA4335"
                d="M9.152 1.327c-1.384 0-2.74.343-3.918.99A7.075 7.075 0 0 0 2.68 4.672l2.298 2.05c.585-1.573 2.23-2.745 4.175-2.745 1.095 0 2.079.336 2.853.996l2.14-1.91c-1.293-1.076-2.982-1.735-4.993-1.735Z"
            />
        </svg>
    )
}

export default googleIcon
